webpackJsonp([251948199435738],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AnjanaSinha = __webpack_require__(239);
	
	var _AnjanaSinha2 = _interopRequireDefault(_AnjanaSinha);
	
	var _GunoorKaur = __webpack_require__(240);
	
	var _GunoorKaur2 = _interopRequireDefault(_GunoorKaur);
	
	var _Kamakshi_Pant = __webpack_require__(241);
	
	var _Kamakshi_Pant2 = _interopRequireDefault(_Kamakshi_Pant);
	
	var _Karuna = __webpack_require__(242);
	
	var _Karuna2 = _interopRequireDefault(_Karuna);
	
	var _Pallavi = __webpack_require__(243);
	
	var _Pallavi2 = _interopRequireDefault(_Pallavi);
	
	var _ParulHariharan = __webpack_require__(244);
	
	var _ParulHariharan2 = _interopRequireDefault(_ParulHariharan);
	
	var _RamyaSuresh = __webpack_require__(245);
	
	var _RamyaSuresh2 = _interopRequireDefault(_RamyaSuresh);
	
	var _Rochelle = __webpack_require__(246);
	
	var _Rochelle2 = _interopRequireDefault(_Rochelle);
	
	var _ShewtaBapat = __webpack_require__(247);
	
	var _ShewtaBapat2 = _interopRequireDefault(_ShewtaBapat);
	
	var _VarshaPoddar = __webpack_require__(248);
	
	var _VarshaPoddar2 = _interopRequireDefault(_VarshaPoddar);
	
	var _VineetaSingh = __webpack_require__(249);
	
	var _VineetaSingh2 = _interopRequireDefault(_VineetaSingh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mentConstant1 = [{
	    imgUrl: _AnjanaSinha2.default,
	    desc: "<div>Anjana is a transactional lawyer with a total of 15 years of experience in private equity and M&A. She began her career working with leading law firms in India, namely Kochhar & Company and Singhania & Partners. She has advised several national and international clients on issues relating to joint venture, mergers and acquisitions, entry strategies in India and issues relating to foreign exchange laws. Before joining Investcorp, she has worked extensively on private equity transactions during her association with Bennett, Coleman & Co. Limited, the largest media conglomerate in India, and RoundGlass Partners (a US based private equity /venture capital investor). Anjana holds B.Com and LL.B. degree from Delhi University.\u201D\n\n        </div>",
	    name: "Anjana Sinha",
	    oldcompany: "Investcorp India",
	    oldpost: "Senior Vice President",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/anjana-sinha-1253168/"
	}, {
	    imgUrl: _GunoorKaur2.default,
	    desc: "<div>Gurnoor Kaur is an investment professional at TA Associates and focuses on investments in business services companies in India. Prior to TA, Gurnoor was at Rothschild & Co. where she was an Associate in the Telecom, Energy and Healthcare group.  She earned a Bachelor of Commerce from Shri Ram College of Commerce, Delhi University and a Master\u2019s in Business Administration from the Indian Institute of Management, Kozhikode.\n       </div>",
	    name: " Gurnoor Kaur",
	    oldcompany: "TA Associates",
	    oldpost: "Growth Equity Investor",
	    newpost: "Senior Vice President",
	    newcompany: "TA Associates",
	    linkedIn: "https://www.linkedin.com/in/gurnoor-kaur-46399432/"
	}, {
	    imgUrl: _Kamakshi_Pant2.default,
	    desc: "<div>Kamakshi is Vice President of Strategy and Marketing at Taggd by PeopleStrong. In her current role, she is responsible for designing and executing the growth and business strategy and special projects for Taggd in collaboration with the Executive Team. In addition to this, she leads the Marketing and Branding initiatives of Taggd and is responsible for enabling the growth of Taggd through differentiated brand positioning, digital marketing, and thought leadership. Creating a Brand\u2019s Identity and bringing it to life through detailed execution is one of her key interest areas. Kamakshi is a music and art enthusiast and in her free time loves experimenting with them.\n        </div>",
	    name: "Kamakshi Pant",
	    oldcompany: "Taggd",
	    oldpost: "Vice President Strategy and Marketing",
	    newpost: "Chief Business Officer Partner",
	    newcompany: "Taggd Work Capital",
	    linkedIn: "https://www.linkedin.com/in/kamakshipant/"
	}, {
	    imgUrl: _Karuna2.default,
	    desc: "<div>Karuna has extensive experience and expertise in early-stage impact and private equity investing in healthcare and renewables. Karuna is building Enzia which is a $40mn sector-focused, an early-stage investment fund investing in health, education and environment sectors.\n        Prior to Enzia, she worked in senior positions at Acumen, Aditya Birla Group and Grasim Industries. Karuna has been a member on the boards of several of Acumen\u2019s portfolio companies including LifeSpring Hospitals, Frontier Markets, Edubridge Learning Systems, and Sewa Grih Rin. Other companies she worked with include Healthcubed, Ayurvaid, and Husk Power Systems. \n        Karuna\u2019s experience has helped her gain deep-rooted insights into India II and III markets, consumer behaviors and cross-sectoral investing. She combines these insights with her eye for detail and proficiency in working with founders to help Enzia\u2019s portfolio companies build strategy and value.\n        Karuna is a CA and holds an MBA from ISB, Hyderabad.\n        \n            </div>",
	    name: "Karuna Jain",
	    oldcompany: "Enzia Ventures",
	    oldpost: "Co - Founder and Partner",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/karuna-jain-10569b7/"
	}, {
	    imgUrl: _Pallavi2.default,
	    desc: "<div>Pallavi specialises in Fund, M&A Joint Ventures General Corporate and Private Equity. She has diverse advisory experience in negotiation, corporate and foreign exchange related advice and regulatory compliances while dealing with authorities, including the RBI, SEBI and the Department of Economic Affairs.  Pallavi is a Company Secretary and holds an LL.B degree from Government Law College \u2013 University of Mumbai. \n\n        </div>",
	    name: "Pallavi Satpute",
	    oldcompany: " AZB & Partners",
	    oldpost: "Counsel ",
	    newpost: "Senior Associate",
	    newcompany: "Al Tamimi & Company",
	    linkedIn: "https://www.linkedin.com/in/pallavi-satpute-5a85a652/"
	}, {
	    imgUrl: _ParulHariharan2.default,
	    desc: "<div>Parul has over 14 years of investing experience across the transaction lifecycle, with her area of focus in financial institutions. She currently works at CDC Group, UK\u2019s development financial institution (DFI) and previously at Aquarius Investment Advisors, a mid-cap growth capital private equity fund. She has experience in making equity investments, portfolio monitoring and exits. Parul has an MBA from the Indian School of Business (ISB), Hyderabad and is also a qualified Chartered Accountant (CA) from the Institute of Chartered Accountants of India (ICAI).\n\n       </div>",
	    name: "Parul Hariharan",
	    oldcompany: "CDC Group PLC",
	    oldpost: "Manager - Financial Institutions, Equity",
	    newpost: "Financial Institutions, Direct Equity, South Asia",
	    newcompany: "British International Investment Plc",
	    linkedIn: "https://www.linkedin.com/in/parul-hariharan-4433402/"
	}, {
	    imgUrl: _RamyaSuresh2.default,
	    desc: "<div>Ramya is a General Corporate and M&A lawyer with 10 years\u2019 experience, currently working as a Counsel in Trilegal. Due to her sector agnostic practice, she led the team in several high-value deals ranging from strategic investments, PE/VC investments, securities sales and purchases, asset and business purchases, co-investments and joint ventures in tech-solution start-ups, renewable energy projects, e-pharmacy, non-banking finance, e-learning, as well as JV/other investment exits.<br/><Br/>\n        Ramya prior to Trilegal worked with DSK Legal, Delhi for 3 years. She is also an alumnus of Amity Law School, New Delhi (Batch of 2011) registered with the Bar Council of Delhi and a Company Secretary. \n        \n       </div>",
	    name: "Ramya Suresh",
	    oldcompany: "Trilegal",
	    oldpost: "Counsel",
	    newpost: "Partner Director",
	    newcompany: "Saraf & Partners Mylan",
	    linkedIn: "https://www.linkedin.com/in/ramya-suresh/"
	}, {
	    imgUrl: _Rochelle2.default,
	    desc: "<div>Ms. D\u2019Souza is a managing director at Lighthouse Advisors, a leading mid-market, private equity investment firm. She co-leads the investment team and specializes in food, healthcare and agri sectors.<br/>\n\n        In addition to Tynor Orthotics, Ms. D\u2019Souza\u2019s current board positions include Wow! Momo Foods, which is India\u2019s largest homegrown QSR brand, and V2 Retail, a leading value retailer.<br/>\n        \n        In her personal time, she serves as a mentor for the YEA Academy and is also an ambassador for Winpe, the network for women in private equity. She was Ranked among the Top 100 Women in Finance by AIWMI in 2019;\n        <Br/>\n        Ms. D\u2019Souza received her MBA from the SP Jain School of Management and holds a Bachelor in Engineering in Electronics from RVCE\n        \n       </div>",
	    name: "Rochelle D'Souza",
	    oldcompany: "Lighthouse Advisors",
	    oldpost: "Managing Director",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/rochelle-dsouza-448169b/"
	}, {
	    imgUrl: _ShewtaBapat2.default,
	    desc: "<div>Shweta Bapat is a Senior Associate at EverSource Capital, Everstone Group. She has over 9 years\u2019 experience in private equity, M&A and equity research. At EverSource Capital, her focused sectors are e-mobility, waste management & renewables. She has extensive experience of working with companies and helping them formulate a growth plan, recommending changes in their existing business plans, structuring and key processes. Prior to EverSource Capital, she has worked with Deutsche Bank. Shweta holds a Bachelor of Management Studies from the University of Mumbai and an MSc Finance degree from Lancaster University, United Kingdom.\n\n         </div>",
	    name: "Shweta Bapat",
	    oldcompany: "EverSource Capital, Everstone Group",
	    oldpost: "Senior Associate",
	    newpost: "Vice President",
	    newcompany: "Ruya Partners",
	    linkedIn: "https://ae.linkedin.com/in/shweta-shastri-5262b441/"
	}, {
	    imgUrl: _VarshaPoddar2.default,
	    desc: "<div>Varsha has been with CDPQ for 5+ years. Varsha covers the Indian market working on the CDPQ India strategy and multiple India deals across listed and private equity. Varsha has in total 9+ years of experience (6+ years in investments & banking and 3+ years working with global accounting firms). Before joining CDPQ Varsha worked with Avendus Capital as an Associate in the Consumer's & financial services team (Investment Banking Division). Prior to her MBA she worked at Deutsche Bank in India as an Analyst in the Corporate Banking team. Varsha holds an MBA from The Indian Institute of Management, Bangalore. Varsha is a Chartered Accountant and secured an AIR of 33 in CA Final along with earning her Bachelors\u2019 degree in Commerce from Narsee Monjee College. Apart from work, Varsha is very passionate about sports. She was a member of the Indian Throwball team representing India at the international level. Varsha follows tennis very religiously and is a big Rafael Nadal fan.  \n\n         </div>",
	    name: "Varsha M. Poddar",
	    oldcompany: "CDPQ India",
	    oldpost: "Senior Associate, Infrastructure",
	    newpost: "Vice President",
	    newcompany: "ESSAR CAPITAL LIMITED",
	    linkedIn: "https://www.linkedin.com/in/varsha-poddar-5548b858/"
	}, {
	    imgUrl: _VineetaSingh2.default,
	    desc: "<div>Vineeta served many leadership positions at various other multi-million-dollar businesses since and successfully building India\u2019s largest beauty subscription service along the way \u2013 Vineeta co-founded SUGAR Cosmetics in 2015 with a single-point agenda of creating world-class makeup products with high-pigmentation that specifically catered to the Indian skin tone. Vineeta in 2021 was able to raise $21 Million (INR 153 Cr) Series C funding round led by Elevation Capital (formerly, SAIF Partners), with existing investors A91 Partners, India Quotient participating and strategic venture debt from Stride Ventures.<Br/><br/>\n        Vineeta has an individual TEDx talk to her credit where she has shared candid details about her journey. She is also a fitness buff with numerous ultra-marathons & triathlons to her credit. Being an avid runner for the last decade, she has completed the Comrades Ultra-marathon which is 89 km long, thrice from 2012-14. Apart from that, Vineeta and her husband are also the first Indian couple to finish the grueling long-distance Ironman triathlon in Austria (3.8km swim, 180km cycle, 42.2km run) \u2013 which is widely regarded as the toughest single-day sporting event in the world. \n        \n        </div>",
	    name: "Vineeta Singh",
	    oldcompany: "SUGAR Cosmetics",
	    oldpost: "CEO & Co-Founder ",
	    newpost: "CEO & Co-Founder",
	    newcompany: "SUGAR Cosmetics",
	    linkedIn: "https://www.linkedin.com/in/vineetasingh/"
	}];
	
	exports.default = mentConstant1;
	module.exports = exports["default"];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AnjanaSinha.2055132b.jpg";

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GunoorKaur.4890e7d2.jpg";

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Kamakshi_Pant.a257ef76.jpg";

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Karuna.fcf592aa.jpg";

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Pallavi.cdcd5c12.jpg";

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ParulHariharan.388e160b.jpg";

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RamyaSuresh.02100d3e.jpg";

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Rochelle.30f94245.jpg";

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ShewtaBapat.e2aeacb6.jpg";

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VarshaPoddar.4b70077d.jpg";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VineetaSingh.c0a94477.jpg";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentConstant = __webpack_require__(157);
	
	var _mentConstant2 = _interopRequireDefault(_mentConstant);
	
	var _Media = __webpack_require__(38);
	
	var _MediaRight = __webpack_require__(55);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { direction: "", className: "teamdetails__wrapper", show: show, onHide: onHide },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc force-overflow" },
	        _react2.default.createElement("div", { className: "item__desc_scr", style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var Index = exports.Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(args) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	
	    return _this;
	  }
	
	  Index.prototype.render = function render() {
	    var location = this.props.location;
	    var isShow = this.state.isShow;
	
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, { title: "Winpe ProClub Mentorship Program | Testimonials.", image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
	      _react2.default.createElement(
	        "div",
	        { className: "mentees-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "heading" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "Testimonials "
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "section_intro_text", style: { textAlign: 'justify' } },
	            "\"Winpe\u2019s mentoring programme provided me with a valuable opportunity to network and openly exchange ideas. It made me think and set goals for myself which I would have not otherwise considered. I am thankful to my mentor for candidly sharing his views, suggestions and experiences with me and for encouraging me to think beyond my set frontiers. Our conversations have helped me develop both on a professional and personal front. I look forward to continuing leveraging the relationships built during the programme.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              " -Anahita Medhora,  Vice President, Everstone Capital, Cohort I Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "\"Winpe\u2019s mentoring program was highly valuable for me \u2013 I entered the same with a very open mind and many aspects to learn on. I am thankful to have found a mentor who was very experienced and was willing to share her thoughts about a variety of things, very openly with me. My mentor and I, both were very serious about this program and used the opportunity to set objectives ahead of our conversations.  This really helped me maximise my learnings. It wasn\u2019t all serious though - many similarities in our journey made us connect a lot more and there was a personal bonding that got created. I would highly recommend the program to the professionals in the investing community.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              " -Anshul Jain, Managing Director, Lighthouse Advisors, Cohort I Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "\u201CAs my fellow mentees and I graduate as the first cohort of the mentorship programme designed by Winpe in collaboration with Russel Reynolds, I am not alone in feeling gratitude for the fantastic platform provided by this programme. The first of its kind programme for women from the PE space, it has been a journey of learning from the experiences of some truly remarkable leaders that has inspired us to strive for delivering higher impact and emboldened us to go beyond our comfort zone. Despite it being a year of virtual connections and conversations, the programme strove to make these mentor-mentee relationships deliver great value. What I take back from this platform is an opportunity to not just build a long lasting relationship of guidance with my mentor but also be associated with a group of exceptional women leaders. Truly grateful to Winpe for this.\u201D",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              " -Asha Krishnan, Operating Director, General Atlantic, Cohort I Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "\"With the Winpe mentoring programme, I had the opportunity to interact with and learn from fabulous leaders, and the other wonderful women in private equity who were part of my cohort. The\" highlight of the programme was the one-on-one mentoring conversations with my mentor, Soumya Rajan, where the sole agenda was my development. Soumya brought her perspective to my context and gave generously of her time, connections and insight to help me grow. I am very grateful to Soumya for being willing to share and build me up. Many thanks to Soumya\u2019s assistant, Allison, who was very thorough about setting up our meetings despite Soumya\u2019s busy schedule. Hurrah to the teams at Winpe and Russell Reynolds for starting and running this timely, thoughtful and well-run programme. \"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Jolly Abraham, Director, True North, Cohort I Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\u201CI look forward to being a part of the Winpe Mentorship Program and interacting and learning from inspiring women to help me build the tools necessary for the next phase of my career.\u201D",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              " -Pallavi Satpute, Counsel, AZB & Partners, Cohort II Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"I have been a part of the second cohort of the Winpe mentorship program in collaboration with Russell Reynolds. Firstly, I want to convey my immense gratitude to Winpe for curating such a programme that is a first of its kind in the industry. Thank you for creating a safe space and a perfect environment to learn and grow! Over the course of this program I had the privilege to learn from the wisdom and experience of my mentor, a relationship I will take with me beyond this program. I urge other firms to sign up to this initiative and offer this great mentoring experience to your fellow senior women colleagues.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Rochelle D'Souza, Managing Director, Lighthouse Advisors, Cohort II Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"I wanted to thank Winpe & Russel Reynolds for this opportunity and design of this unique mentorship program. My mentor asked the difficult questions and pushed me to think about my career strategically. The conversations also helped articulate my ambition & leadership style, in a way I hadn't thought about before. I believe this is just the start of a much longer relationship. This has been a very valuable program, thoughtfully designed by Winpe.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Parul Hariharan, Manager - Financial Institutions, Equity, BII, Cohort II Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"As I stepped into a new territory of raising and managing my own fund I leaned on guidance from experienced fund managers. In particular, I am grateful to VT Bharadwaj of A91 for his time and practical advice and to Winpe for enabling this relationship.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Karuna Jain, Co-Founder & Partner, Enzia Ventures, Cohort II Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"I am excited to work closely with Winpe and the illustrious mentors to 'change the narrative' of my professional journey and use the experience to guide upcoming talent\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Arshita Kapoor, Investment Professional, Quadria Capital, Cohort III Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"Really excited to embark on this journey designed to make women shine in private equity.  A mentor is someone who guides and helps us find the light within ourselves and I am really looking forward to engaging and working with one through this programme. Thank you Winpe and RRA for having me as a part of this cohort \"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Neha Misra, Co-Founder & CEO, The Fin Lit Project, Cohort III Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"I am excited to be a part of the program as it gives me the unique opportunity to interact closely and learn from remarkable industry leaders.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Parita Ashar, Vice- President, Oman India Joint Investment Fund Management, Cohort III Mentee"
	            ),
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            "\"What attracts me about this program is the networking I will have with the PE industry woman professionals. I am looking forward to learn from the experiences of my mentors.\"",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { color: '#BF2026', fontWeight: '600' } },
	              "-Swati Bansal, Principal - Private Equity, NIIF, Cohort III Mentee"
	            )
	          )
	        ),
	        _react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-testimonials-index-js-90e57f54dfdbf86839bc.js